var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M18 25.5q.637 0 1.069-.431.43-.432.431-1.069 0-.637-.431-1.069A1.45 1.45 0 0 0 18 22.5q-.637 0-1.069.431A1.45 1.45 0 0 0 16.5 24q0 .637.431 1.069.432.43 1.069.431m-1.5-6h3v-9h-3zm-4.125 12L4.5 23.625v-11.25L12.375 4.5h11.25l7.875 7.875v11.25L23.625 31.5zm1.275-3h8.7l6.15-6.15v-8.7L22.35 7.5h-8.7L7.5 13.65v8.7z"
  })));
};
export { SvgReport as ReactComponent };
export default __webpack_public_path__ + "static/media/report.23dc4df3.svg";